import { Injectable } from '@angular/core';
import { LegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { Urls } from '@core/config/urls';

@Injectable()
export class DashboardService extends LegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/main/dashboard/widgets/load';
	}

	public getData(key: string, data: any): Observable<any> {
		return this._restClientService.post(`${this.apiUrl}/${key}`, data);
	}

	public getCollectionStatus(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('COLLECTION_STATUS_DATA', searchData);
	}

	public getPaymentStatus(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('PAYMENT_STATUS_DATA', searchData);
	}

	public getBalanceStatus(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('BALANCE_STATUS_DATA', searchData);
	}

	public getCollectionAndPaymentStatus(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('COLLECTION_AND_PAYMENT_STATUS_DATA_PER_MONTH', searchData);
	}

	public getTopSellingAmount(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {
				type: 'AMOUNT',
			},
		};
		return this.getData('TOP_SELLING_PRODUCT_DATA', searchData);
	}

	public getTopSellingQuantity(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {
				type: 'QUANTITY',
			},
		};
		return this.getData('TOP_SELLING_PRODUCT_DATA', searchData);
	}

	public getTotalStockCost(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};

		return this.getData('TOTAL_STOCK_COST_DATA', searchData);
	}

	public getDailySales(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('DAILY_SALES_DATA', searchData);
	}
	public getDailyCollections(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('DAILY_COLLECTIONS_DATA', searchData);
	}

	public getDailyPayments(dateCriterionKeyword: string = 'LAST_MONTH'): Observable<any> {
		const searchData = {
			dateCriterionKeyword,
			additionalCriteria: {},
		};
		return this.getData('DAILY_PAYMENTS_DATA', searchData);
	}
}
